import { API_URL } from "./client";

export async function checkEmailExists(email: string): Promise<{ email: string }> {
  const res = await fetch(`${API_URL}/exist-email/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  });

  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data?.error ?? "email doesn't exist");
  }

  return res.json();
}
